<!-- universal link 頁面 /pxplink/web/:scheme?code={code} -->
<!-- oidc link 短連結 /oidclink/web/:scheme?url={url} -->
<template>
  <div class="pxplink_page_wrapper">
    <div
      v-if="!isQRCodeShow"
      class="redirect_wrapper"
    >
      <div class="content_container">
        <picture>
          <source
            media="(min-width: 768px)"
            :srcset="require('@/assets/imgs/redirect/logo@3x.png')"
          >
          <source
            media="(max-width: 320px)"
            :srcset="require('@/assets/imgs/redirect/logo.png')"
          >
          <img
            class="pxplus_logo"
            :src="require('@/assets/imgs/redirect/logo@2x.png')"
            alt="logo"
          >
        </picture>

        <div class="desc_para">
          請稍後，頁面即將跳轉...
        </div>

        <div class="redirect_pic_block">
          <picture>
            <source
              media="(min-width: 768px)"
              :srcset="require('@/assets/imgs/redirect/img_redirect@3x.png')"
            >
            <source
              media="(max-width: 320px)"
              :srcset="require('@/assets/imgs/redirect/img_redirect.png')"
            >
            <img
              class="redirect_pic"
              :src="require('@/assets/imgs/redirect/img_redirect@2x.png')"
              alt="redirect"
            >
          </picture>
        </div>
      </div>

      <div class="store_block">
        <p class="store_desc">
          還沒安裝全支付嗎？
        </p>

        <button
          ref="storeBtnRef"
          class="store_btn"
          :data-clipboard-text="recommendCode"
          :disabled="!isApiResponse"
          @click="goToStore"
        >
          前往下載
        </button>
      </div>
    </div>

    <div
      v-else
      class="qrcode_wrapper"
    >
      <div class="nav">
        <picture>
          <source
            media="(min-width: 768px)"
            :srcset="require('@/assets/imgs/redirect/navbar_logo@3x.png')"
          >
          <source
            media="(max-width: 320px)"
            :srcset="require('@/assets/imgs/redirect/navbar_logo.png')"
          >
          <img
            class="pxplus_logo"
            :src="require('@/assets/imgs/redirect/navbar_logo@2x.png')"
            alt="navbar_logo"
          >
        </picture>
      </div>

      <div class="container">
        <div class="title_block">
          <p class="text_title">
            {{ isQRCodeGenerated ? '請使用全支付APP掃描條碼' : ' ' }}
          </p>
        </div>

        <div
          v-show="isQRCodeGenerated"
          id="payment_qrcode"
        >
          <div class="qrcode_content">
            <div class="code_block">
              <canvas ref="qrcodeCanvasRef" />

              <span class="qrcode_logo_block">
                <img
                  class="qrcode_logo"
                  :src="require('@/assets/imgs/redirect/qrcode_logo.png')"
                  alt="logo icon"
                >
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="!isQRCodeGenerated"
          class="qrcode_error"
        >
          <div class="skeleton" />
        </div>
      </div>
    </div>

    <component :is="dialogName" />
  </div>
</template>

<script>
import { ref, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { stringifyQuery } from 'vue-router';
import { baseUrl, ecURL, PXPlusLink, PXPayLink, downloadAosUrl, downloadIosUrl } from '@/config/config';
import { saveRecommendCode } from '@/libs/API/apis';
import { MsgDialog } from '@/components/Modal/';
import useCommon from '@/libs/globalComposition';
import UTF8 from 'crypto-js/enc-utf8';
import Base64 from 'crypto-js/enc-base64';
import ClipboardJS from 'clipboard';
import device from 'current-device';
import QRCode from 'qrcode';

export default {
  name: 'PxPLinkPage',
  components: {
    MsgDialog
  },
  setup () {
    const { currentRoute, dialogName } = useCommon();
    const { scheme } = currentRoute.params;
    /**
     * appType - 授扣類型
     * 2：預設授扣 & 跨境
     * 6：摩根
     * 7：不會有 code，直接進入 APP 頁面並接 query string（如：推薦碼）
     * 8：OpenID 導流
     * 不帶 appType：Apple、支付工具反綁（如：郵局）
     */
    const { code, appType, recommendCode } = currentRoute.query;
    const queryStr = stringifyQuery(currentRoute.query);

    const appTypeNumber = Number(appType);
    const isOpenIDRedirect = appTypeNumber === 8;
    const isCopyBehavior = appTypeNumber === 7 && recommendCode;
    const PXPlusDownloadUrl = device.ios() ? downloadIosUrl : downloadAosUrl;

    const clipboard = new ClipboardJS('.store_btn');

    let ecLink = '';

    let pxplusDownloadTimer = '';
    let openSecondAppTimer = '';

    const storeBtnRef = ref(null);
    const qrcodeCanvasRef = ref(null);
    const isQRCodeShow = ref(false);
    const isApiResponse = ref(true);
    const isQRCodeGenerated = ref(false);

    clipboard.on('success', (e) => {
      window.location.href = ecLink;
      e.clearSelection();
    });

    const handleRedirectLink = async () => {
      if (device.desktop() && (!appTypeNumber || isOpenIDRedirect)) {
        // 原版是會跳轉到EC QRcode 頁面，並顯示 QR Code，目前改為直接顯示 QR Code
        isQRCodeShow.value = true;

        nextTick(() => createQRCode());

        return '';
      } else if (isCopyBehavior) {
        ecLink = device.ios() ? `${downloadIosUrl}?` : `${downloadAosUrl}&`;
        ecLink += `referrer=${recommendCode}`;

        if (device.ios()) {
          const { height, width } = window.screen;
          const agentData = window.navigator.userAgent.replace(/^(.*)iPhone OS ([^ ]+)(.*)$/gm, '$2');

          isApiResponse.value = false;

          await saveRecommendCode({
            recommend_code: recommendCode,
            os_version: `iOS-${agentData.replaceAll('_', '.')}`,
            screen_resolution_height: height.toString(),
            screen_resolution_width: width.toString()
          });

          isApiResponse.value = true;

          nextTick(() => {
            storeBtnRef.value.click();
          });

          return '';
        }
      } else if (!appTypeNumber) {
        ecLink = PXPlusDownloadUrl;
      } else if (isOpenIDRedirect) {
        handleOIDCLink();

        return '';
      } else {
        ecLink = `${ecURL}page_redirect?data=${code}&destination=PxPlus&appType=${appTypeNumber}`;
      }

      return ecLink;
    };

    const createQRCode = () => {
      const currentUrl = `${baseUrl}${isOpenIDRedirect ? 'oidclink' : 'pxplink'}/web/${scheme}?${queryStr}`;

      QRCode.toCanvas(qrcodeCanvasRef.value, currentUrl, { width: 200, margin: 0 })
        .then(() => {
          isQRCodeGenerated.value = true;
        })
        .catch(() => {
          isQRCodeGenerated.value = false;
        });
    };

    const goToStore = () => {
      if (!isCopyBehavior) window.location.href = ecLink;
    };

    const visibleAction = () => {
      if (document.visibilityState !== 'hidden') return;
      if (openSecondAppTimer) clearTimeout(openSecondAppTimer);
      if (pxplusDownloadTimer) clearTimeout(pxplusDownloadTimer);

      window.location.href = 'https://www.pxpayplus.com/';
    };

    const handleOIDCLink = () => {
      const createDeepLinkUrl = (prefix = PXPlusLink) => `${prefix}://${scheme}?${queryStr}`;
      const agentType = window.navigator.userAgent.match(/(PXPayPlus_SDK|PXPayPlus)/gi)?.[0];

      if (agentType) {
        window.location.replace(Base64.parse(currentRoute.query.url).toString(UTF8));
      } else {
        window.location.replace(createDeepLinkUrl());

        openSecondAppTimer = setTimeout(() => {
          window.location.href = createDeepLinkUrl(PXPayLink);

          pxplusDownloadTimer = setTimeout(() => {
            window.location.href = PXPlusDownloadUrl;
          }, 5500);
        }, 3000);
      }

      document.addEventListener('visibilitychange', visibleAction);
    };

    onMounted(async () => {
      const redirectLink = await handleRedirectLink();
      if (redirectLink) window.location.href = redirectLink;
    });

    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', visibleAction);
      clipboard.destroy();
    });

    return {
      dialogName,
      appType,
      isQRCodeShow,
      qrcodeCanvasRef,
      goToStore,
      storeBtnRef,
      isApiResponse,
      recommendCode,
      isQRCodeGenerated
    };
  }
};
</script>

<style>
#app > .container {
  margin-top: 0px;
  min-height: auto;
}
</style>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

.redirect_wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 100vh;
  max-height: 100vh;

  .content_container {
    flex-grow: 1;
    overflow-y: hidden;
    padding: 32px 32px 0px;
    width: 100%;

    .pxplus_logo {
      height: 42px;
    }

    .desc_para {
      font-size: 17px;
      font-weight: 700;
      line-height: 24px;
      margin: 32px 0px 40px;
    }

    .redirect_pic_block {
      width: 100%;

      .redirect_pic {
        height: auto;
        margin: 0px auto;
        max-width: 100%;
        object-fit: contain;
      }
    }
  }

  .store_block {
    align-self: flex-end;
    background: #f8f8f8;
    padding: 24px 24px 29px;
    width: 100%;

    .store_desc {
      font-size: 16px;
      line-height: 24px;
      margin: 0px 8px 20px;
    }

    .store_btn {
      background: transparent;
      border: 2px solid $black;
      border-radius: 28.5px;
      color: $black;
      cursor: pointer;
      font-size: 17px;
      font-weight: 700;
      line-height: 22px;
      outline: none;
      padding: 15px 0px;
      width: 100%;

      &:disabled {
        cursor: not-allowed;
      }
    }
  }
}

.qrcode_wrapper {
  background: $mono_10;
  height: 100vh;
  text-align: center;

  .nav {
    background: $white;
    padding: 25px 0px 25px 50px;
    text-align: left;

    .pxplus_logo {
      width: 155px;
      height: 31px;
    }
  }

  .container {
    .title_block {
      .text_title {
        @include font-size-24;

        display: block;
        font-weight: 800;
        margin: 100px 0px 50px;
        min-height: 33px;
      }
    }

    // 收款碼區塊
    #payment_qrcode {
      margin: 0 auto;
      width: 280px;

      .qrcode_content {
        background: $mono_10;
        text-align: center;

        .code_block {
          background: $white;
          border-radius: 10px;
          border: 1px solid $mono_30;
          display: inline-block;
          padding: 25px;
          position: relative;
          height: 250px;
          width: 250px;

          .qrcode_logo_block {
            height: 50px;
            position: absolute;
            right: 50%;
            top: 50%;
            transform: translate(50%, -50%);
            width: 50px;

            .qrcode_logo {
              width: 36px;
              height: 36px;
            }
          }
        }
      }
    }

    .qrcode_error {
      text-align: center;

      .skeleton {
        background: rgba($black, 0.1);
        border-radius: 10px;
        display: inline-block;
        height: 250px;
        width: 250px;
      }
    }
  }
}

@media screen and (max-width: 1024px) and (min-width: 768px) {
  .qrcode_wrapper {
    .container {
      .qrcode_error {
        margin-top: 182px;
      }
    }
  }
}

@media screen and (max-width: 1023px) and (min-width: 414px) {
  .qrcode_wrapper {
    .nav {
      padding: 25px 0px 25px 30px;
    }
  }
}
</style>
